<template lang="pug">
.form-new-rent
  h2 按日续交租金

  .ui.icon.warning.message
    i.warning.icon
    .content
      .header
        | 非正常業務
      p 非特殊情況請勿使用此功能

  el-form.ui.form(:model='form')
    .three.fields
      el-form-item.ui.field.required(prop='date_start')
        label 开始日期
        datepicker(v-model='form.date_start', placeholder='开始日期', disabled)
      el-form-item.ui.field.required(prop='rent_day')
        label 时长 (日)
        el-input-number(v-model='form.rent_day', :min='0', :max='30')
      el-form-item.ui.field.required(prop='date_end')
        label 结束日期
        datepicker(v-model='form.date_end', placeholder='结束日期', :min='form.date_start', :max='date_contract_end')
    .three.fields
      el-form-item.field.required(prop='price_day')
        label 日租金 (租金+管理費) / 30
        el-input-number(v-model='form.price_day', type='number', :controls='false')
      el-form-item.field.required(prop='amount_due')
        label 应付租金
        el-input-number(v-model='form.amount_due', type='number', disabled, :controls='false')
      el-form-item.field.required(prop='amount_paid')
        label 实收租金
        el-input-number(v-model='form.amount_paid', type='number', :controls='false')

    .three.fields
      el-form-item.field(prop='payment_method')
        label 支付方式
        payment-method-select(v-model='form.payment_method')

    el-form-item.ui.field(prop='note')
      label 备注
      textarea(v-model='form.note', rows='2')

    .ui.field
      receipts(v-show='receipts && receipts.length', :receipts='receipts')

    .ui.field
      .ui.button.themed(@click='submit') 确认缴交
      .ui.button(@click='cancel') 取消
</template>

<script>
import { MakeForm } from '../../utils'
import { Datepicker, Receipts, PaymentMethodSelect } from '../basic'

export default {
  name: 'form-new-rent',
  props: ['contract_id', 'no'],
  components: { Datepicker, PaymentMethodSelect, Receipts },
  data() {
    return {
      form: {
        _room: null,
        _contract: null,
        date_start: null,
        date_end: null,
        rent_day: 1,
        price_day: 1000,
        amount_paid: 0,
        amount_due: 0,
        management_fee: 0,
        network_fee: 0,
        management_fee_month: 0,
        network_fee_month: 0,
        payment_method: 'cash',
        note: '',
        state: 'paid',
      },
    }
  },
  mounted() {
    this.init()
  },
  watch: {
    contract_id() {
      this.init()
    },
    'form.rent_day': function () {
      this.update_date()
      this.update_price()
    },
    'form.price_day': function () {
      this.update_price()
    },
    'form.management_fee_month': function () {
      this.update_price()
    },
    'form.network_fee_month': function () {
      this.update_price()
    },
  },
  computed: {
    contract() {
      return this.$store.getters.contract(this.contract_id)
    },
    date_start() {
      if (this.form.date_start)
        return this.$moment(this.form.date_start)
    },
    date_contract_expired() {
      if (this.contract && (this.contract.date_expire || this.contract.date_start))
        return this.$moment(this.contract.date_expire || this.contract.date_start)
    },
    date_contract_end() {
      if (this.contract && this.contract.date_end)
        return this.$moment(this.contract.date_end)
    },
    rent_day_max() {
      if (this.date_contract_end && this.date_contract_expired)
        return this.$moment.monthsBetween(this.date_contract_end, this.date_contract_expired)
      return 36
    },
    receipts() {
      return [
        {
          name: '租金',
          unit: '日',
          unit_price: this.form.price_day,
          quantity: this.form.rent_day,
          money: this.form.amount_paid,
        },
      ]
    },
  },
  methods: {
    init() {
      this.form._room = this.contract._room
      this.form._contract = this.contract_id
      this.form.date_start = this.$moment(this.contract.date_expire || this.contract.date_start).startOf('days')
      this.form.rent_day = 10
      this.form.price_day = Math.ceil(((this.contract.price_month + this.contract.management_fee_month) / 30) * 1.1)
      this.update_date()
      this.update_price()
    },
    update_date() {
      this.form.date_end = this.$moment(this.form.date_start)
        .add(this.form.rent_day, 'days')
        .toDate()
    },
    update_price() {
      this.form.management_fee = this.form.management_fee_month * this.form.rent_day
      this.form.network_fee = this.form.network_fee_month * this.form.rent_day
      this.form.amount_due = this.form.rent_day * this.form.price_day
      this.form.amount_paid = this.form.amount_due
    },
    print_fee() {
      const quantity = `${this.form.rent_day}日`
      const note = `${this.$formatters.date.to_date_cn(this.form.date_start)} - ${this.$formatters.date.to_date_cn(this.form.date_end)}`
      const room = this.no
      const payment_method = this.$formatters.payment_method(this.form.payment_method, this.$store.state.summary.payment_methods) || undefined
      this.$templater.request('other_fee', {
        room_no: this.no,
        fees: [
          {
            room,
            subject: '日租金',
            note,
            quantity,
            payment_method,
            money: this.form.price_day * this.form.rent_day,
          },
        ],
      })
    },
    cancel() {
      this.$router.back()
    },
    submit_form: MakeForm({
      type: 'post',
      url: 'rents/new_by_day',
      confirm: '确认缴交租金？',
      payload() {
        return this.form
      },
      $afterSuccess() {
        this.print_fee()
        this.$router.$go.room({ no: this.no })
      },
    }),
    submit() {
      this.submit_form()
    },
  },
}
</script>



// WEBPACK FOOTER //
// FormNewRentByDay.vue?6db8f7c2